// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-conta {
    /* margin-left: 30px; */
    /* max-height: 260px; */
    /* overflow: auto; */
}

.item {
    display: block;
    /* min-height: 54px; */
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 0px 0px 5px 0px;
}

.item-alarm {
    margin-left: -30px;
    width: calc(100% + 30px);
}

.remove {
    position: relative;
    top: 4px;
    right: 0px;
}

.item-range {
    display: inline-block;
    min-width: 320px;
    max-width: 320px;
    width: 320px;
}

.item-minmax {
    display: inline-block;
    width: 100%;
}

.item-step {
    display: inline-block;
    width: 100%;
    margin-top: 5px;
}

.item-unit {
    display: inline-block;
    /* width: 520px; */
}

.item-remove {
    float: right;
    /* padding-top: 6px; */
    /* min-width: 140px; */
}

.panel-color-class {
    position: relative;
    top: 30px;
}

.panel-color {
    display: inline-block;
    padding-top: 10px;
    max-width: 60px;
    /* border: 1px solid rgba(0,0,0,0.1); */
    height: 21px;
    line-height: 12px;
    margin-right: 25px;
}

.option-color {
    height: 32px !important;
}

.panel-color-class {
    margin-top: 30px !important;
}

.input-range {
    display: inline-block;
    max-width: 80px;
}

.input-range input {
    font-size: 15px;
    text-align: center;
}

.input-minmax {
    display: inline-block;
    max-width: 80px;
}

.input-minmax input {
    font-size: 15px;
    text-align: center;
}

.input-step {
    display: inline-block;
    max-width: 80px;
}

.input-step input {
    font-size: 15px;
    text-align: center;
}

.input-minmax-cb {
    font-size: 15px;
}

::ng-deep .input-range .input-step .input-minmax .mat-form-field-wrapper {
    margin-bottom: -15px !important;
}

::ng-deep .input-range .input-step .input-minmax .mat-form-field-infix {
    padding-top: 1px;
    padding-bottom: 5px;
}

.input-step input {
    font-size: 15px;
    text-align: center;
}

.input-slider {
    display: inline;
    /* max-width: 160px; */
}

::ng-deep .input-slider span {
    font-size: 14px !important;
}

.toolbox {
    margin-top: 3px;
    margin-bottom: 3px;
}

.toolbox button {
    margin-right: 8px;
    margin-left: 8px;
}

.slider-field span {
    padding-left: 2px;
    text-overflow: clip;
    max-width: 125px;
    white-space: nowrap;
    overflow: hidden;
}

.slider-field mat-slider {
    background-color: #f1f3f4;
    height: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/app/gauges/gauge-property/flex-input/flex-input.component.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,2CAA2C;IAC3C,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,uCAAuC;IACvC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB","sourcesContent":[".grid-conta {\n    /* margin-left: 30px; */\n    /* max-height: 260px; */\n    /* overflow: auto; */\n}\n\n.item {\n    display: block;\n    /* min-height: 54px; */\n    width: 100%;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n    padding: 0px 0px 5px 0px;\n}\n\n.item-alarm {\n    margin-left: -30px;\n    width: calc(100% + 30px);\n}\n\n.remove {\n    position: relative;\n    top: 4px;\n    right: 0px;\n}\n\n.item-range {\n    display: inline-block;\n    min-width: 320px;\n    max-width: 320px;\n    width: 320px;\n}\n\n.item-minmax {\n    display: inline-block;\n    width: 100%;\n}\n\n.item-step {\n    display: inline-block;\n    width: 100%;\n    margin-top: 5px;\n}\n\n.item-unit {\n    display: inline-block;\n    /* width: 520px; */\n}\n\n.item-remove {\n    float: right;\n    /* padding-top: 6px; */\n    /* min-width: 140px; */\n}\n\n.panel-color-class {\n    position: relative;\n    top: 30px;\n}\n\n.panel-color {\n    display: inline-block;\n    padding-top: 10px;\n    max-width: 60px;\n    /* border: 1px solid rgba(0,0,0,0.1); */\n    height: 21px;\n    line-height: 12px;\n    margin-right: 25px;\n}\n\n.option-color {\n    height: 32px !important;\n}\n\n.panel-color-class {\n    margin-top: 30px !important;\n}\n\n.input-range {\n    display: inline-block;\n    max-width: 80px;\n}\n\n.input-range input {\n    font-size: 15px;\n    text-align: center;\n}\n\n.input-minmax {\n    display: inline-block;\n    max-width: 80px;\n}\n\n.input-minmax input {\n    font-size: 15px;\n    text-align: center;\n}\n\n.input-step {\n    display: inline-block;\n    max-width: 80px;\n}\n\n.input-step input {\n    font-size: 15px;\n    text-align: center;\n}\n\n.input-minmax-cb {\n    font-size: 15px;\n}\n\n::ng-deep .input-range .input-step .input-minmax .mat-form-field-wrapper {\n    margin-bottom: -15px !important;\n}\n\n::ng-deep .input-range .input-step .input-minmax .mat-form-field-infix {\n    padding-top: 1px;\n    padding-bottom: 5px;\n}\n\n.input-step input {\n    font-size: 15px;\n    text-align: center;\n}\n\n.input-slider {\n    display: inline;\n    /* max-width: 160px; */\n}\n\n::ng-deep .input-slider span {\n    font-size: 14px !important;\n}\n\n.toolbox {\n    margin-top: 3px;\n    margin-bottom: 3px;\n}\n\n.toolbox button {\n    margin-right: 8px;\n    margin-left: 8px;\n}\n\n.slider-field span {\n    padding-left: 2px;\n    text-overflow: clip;\n    max-width: 125px;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.slider-field mat-slider {\n    background-color: #f1f3f4;\n    height: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
